/**
 * PebbleVisualiser — Audio-reactive DENiZEN pebble ring.
 *
 * Uses the official Denizen_Pebbles.png logo image and animates it:
 * - Active: scales based on average audio level (smooth CSS transition)
 * - Idle: gentle breathing pulse via CSS animation
 */

interface PebbleVisualiserProps {
  /** 7 values, each 0–1, from useAudioLevel */
  bars: readonly number[]
  /** Whether recording is active (enables audio reactivity) */
  isActive: boolean
  className?: string
}

export function PebbleVisualiser({ bars, isActive, className }: PebbleVisualiserProps) {
  // Average of all bars gives a smooth overall audio level
  const avgLevel = isActive && bars.length > 0
    ? bars.reduce((sum, v) => sum + v, 0) / bars.length
    : 0

  // Scale range: 0.95 (silent) to 1.12 (loud) when active
  const scale = isActive ? 0.95 + avgLevel * 0.17 : 1

  return (
    <div
      className={className}
      style={{ width: 160, height: 160 }}
      aria-hidden="true"
      role="presentation"
    >
      <img
        src="/images/brand/Denizen_Pebbles.png"
        alt=""
        width={160}
        height={160}
        draggable={false}
        style={{
          transform: isActive ? `scale(${scale.toFixed(3)})` : undefined,
          transition: isActive ? 'transform 120ms ease-out' : undefined,
          animation: !isActive ? 'pebble-breathe 4s ease-in-out infinite' : undefined,
        }}
      />
    </div>
  )
}
